if (!customElements.get('luzz-inferno-sync')) {
  customElements.define('luzz-inferno-sync', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-inferno-config]').textContent);
      this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.page = this.closest('main') || document;
      this.picker = this.root?.querySelector('high-variant-selects');
      if (!this.root || !this.picker) return;
      this.originalUpdateBlock = this.picker.updateBlock;
      const controller = this;
      this.wrappedUpdateBlock = function(html, blockId, ...args) {
        if (blockId === 'Variant-Selects') controller.syncMedia(html);
        return controller.originalUpdateBlock.call(this, html, blockId, ...args);
      };
      this.picker.updateBlock = this.wrappedUpdateBlock;
      this.onPopState = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.config[id];
        if (!variant) return;
        const input = [...this.picker.querySelectorAll('input')]
          .find(element => element.value === variant.title);
        if (input && !input.checked) input.click();
      };
      window.addEventListener('popstate', this.onPopState);
      if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = webvista.subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data?.sectionId !== this.dataset.section) return;
          this.syncMedia(event.data.html);
          this.apply(String(event.data.variant?.id));
        });
      }
      this.dataset.currentVariant = this.dataset.selected;
    }

    disconnectedCallback() {
      if (this.picker?.updateBlock === this.wrappedUpdateBlock) {
        this.picker.updateBlock = this.originalUpdateBlock;
      }
      window.removeEventListener('popstate', this.onPopState);
      this.unsubscribe?.();
    }

    syncMedia(html) {
      if (!html) return;
      const sectionId = this.picker.sourceSectionId || this.dataset.section;
      const source = html.getElementById(`Media-Gallery-${sectionId}`);
      const gallery = this.root.querySelector('media-gallery');
      if (!source || !gallery || source.dataset.infernoVersion === gallery.dataset.infernoVersion) return;
      const sourceModal = html.getElementById(`ProductModal-${sectionId}`);
      const modal = document.getElementById(`ProductModal-${this.dataset.section}`);
      if (sourceModal && modal) modal.replaceWith(document.importNode(sourceModal, true));
      // Modal openers cache their target during construction, so replace the modal first.
      gallery.replaceWith(document.importNode(source, true));
    }

    apply(id) {
      const variant = this.config[String(id)];
      if (!variant) return;
      this.page.querySelectorAll('[data-inferno-detail-image]').forEach(image => {
        this.updateImage(image, variant.details[Number(image.dataset.infernoDetailImage)]);
      });
      this.page.querySelectorAll('[data-inferno-featured-image]').forEach(image => {
        this.updateImage(image, variant.image);
      });
      const title = variant.title === 'Inferno' ? 'Luzz Pro 4 Inferno' : `Luzz Pro 4 ${variant.title}`;
      this.page.querySelectorAll('[data-inferno-product-title]').forEach(element => {
        element.textContent = title;
      });
      this.page.querySelectorAll('[data-inferno-product-price]').forEach(element => {
        element.textContent = variant.price;
      });
      this.page.querySelectorAll('[data-inferno-bundle-button]').forEach(button => {
        button.setAttribute('data-product-2-id', String(id));
      });
      this.dataset.currentVariant = String(id);
    }

    updateImage(image, data) {
      if (!data?.src) return;
      if (image.getAttribute('src') !== data.src) {
        image.removeAttribute('srcset');
        image.src = data.src;
      }
      image.alt = data.alt || '';
      if (data.width && data.height) {
        image.width = data.width;
        image.height = data.height;
      }
    }
  });
}
